import {action, computed, observable, makeObservable, runInAction} from 'mobx';
import {RuleModel} from '../baseModel';
import {SearchTypeAI, TSearchTypeAI} from './constants';
import {aiRuleDefaults} from './defaults';
import type {AIRule} from './types';
import {validateAIRule} from './validate';

export class AIRuleModel extends RuleModel<TSearchTypeAI> implements AIRule {
	readonly elementType = SearchTypeAI;

	elementSubType1: 0 = 0;
	elementSubType2: 0 = 0;
	elementValue1 = aiRuleDefaults.elementValue1;
	elementValue2: '' = '';
	elementValue3: '' = '';

	get isValid() {
		const validation = validateAIRule(this);
		this.setValidationErrors(this.dirty && validation ? validation : undefined);
		if (!validation) return true;
		return false;
	}

	constructor(params?: Partial<Omit<AIRule, 'elementType'>>) {
		super();

		runInAction(() => {
			Object.assign(this, params);
		});

		makeObservable(this, {
			elementValue1: observable,
			isValid: computed,
			setElementSubType1: action,
			setElementValue1: action,
		});
	}

	/** stubbed */
	setElementSubType1() {}

	/** stubbed */
	setElementSubType2() {}

	/**
	 * Set ai value
	 * @param elementValue1 ai value
	 */
	setElementValue1(elementValue1: string) {
		this.elementValue1 = elementValue1;
		this.dirty = true;
	}

	/** stubbed */
	setElementValue2() {}

	/** stubbed */
	setElementValue3() {}
}

export default AIRuleModel;
